export default [
    //详情页
    {
        path:'/expertDetail',
        name:'expertDetail',
        component: () => import('@/page/expert/expertDetail')
    },
    //专家入驻
    {
      path:'/expertJoin',
      name:'expertJoin',
      component: () => import('@/page/expert/expertJoin')
    }
  ]